import React from 'react';
import ReactPlayer from 'react-player';
import ReactLoading from 'react-loading';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if';
import ScrollMenu from 'react-horizontal-scrolling-menu';

// import other components within the same project here

import SubmissionDetailStage from "../../views/retriever/SubmissionDetailStage.jsx";
import CompareAnswerDialog from "../../views/retriever/CompareAnswerDialog.jsx";
import StatisticsDialog from "../../views/retriever/StatisticsDialog.jsx";
import Config from "../../Config.jsx";
import Localization from "../../Localization.jsx";
import Helper from "../../Helper.jsx"
import PannellumVideoPlayer from "../../views/stage/MoviePlayer/PannellumVideoPlayer.jsx";
import { PannellumVideo } from "pannellum-react";

import {
  Button,
  Card,
  CardHeader,
  CardContent,
  Typography,
  Slider,
  FormControl,
  Select,
  MenuItem,
  Grid,
  CardActionArea,
  Icon,
  IconButton,
  withTheme,
  Tooltip,
  Dialog,
  DialogContent,
} from '@material-ui/core';
import { red } from '@material-ui/core/colors';

class HeatmapDetail extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      heatmapId: 0,
      heatmap_path: "",
      heatmap_json_path: "",

      // heatmap json data
      heatmapObj: null,
      UTCTimeStamp: [],
      UTCTimeStamp_controlPanelManipulation: [],
      UTCTimeStamp_tagInteractions: [],
      locale_id: 0,
      manipulationKind: [],
      multiplier: 0,
      stage_id: 0,
      tagInteractions: [],
      tagKind: [],
      tagRemarks: [],
      time_interval: 0,
      x_focus: [],
      y_focus: [],
      //

      tn_path: "",
      video_path: "",
      radius: 96,
      video_radius: 20,
      resolution: 171,
      alpha: 0.5,
      video_alpha: 0.5,
      video_mode: 0, // 0: standard, 1: filling
      normalize: 0,
      playedSeconds: 0,
      showHeatmapAdvanced: false,
      showObservationAdvanced: false,
      showImageModal: false,
      selectedImage: "",
      imageScale: 1,
    };
    autoBind(this);

    this.refresh();
  }

  reactPlayerOnProgress(data) {
    let playedSeconds = parseFloat(data.playedSeconds);
    this.setState({
      playedSeconds: playedSeconds,
    });
    this.state.playedSeconds = playedSeconds;

    for(let i = 0; i < this.state.UTCTimeStamp_controlPanelManipulation.length; i++){
      var currentSeconds = Helper.UTCTimestampSecondsBetween(this.state.UTCTimeStamp_controlPanelManipulation[i], this.state.UTCTimeStamp[0]);
      if(this.state.playedSeconds < currentSeconds){
        // scroll to this item
        this.refs.scrollMenuManipulation.state.translate = Math.min(0, -i+1)*180;
        break;
      }
    }

    for(let i = 0; i < this.state.UTCTimeStamp_tagInteractions.length; i++){
      var currentSeconds = Helper.UTCTimestampSecondsBetween(this.state.UTCTimeStamp_tagInteractions[i], this.state.UTCTimeStamp[0]);
      if(this.state.playedSeconds < currentSeconds){
        // scroll to this item
        this.refs.scrollMenuInteration.state.translate = Math.min(0, -i+1)*180;
        break;
      }
    }
  }

  scrollMenuManipulationCardClicked(triggerTime){
    this.refs.reactPlayer.seekTo(triggerTime, 'seconds');
  }

  scrollMenuInterationCardClicked(triggerTime){
    this.refs.reactPlayer.seekTo(triggerTime, 'seconds');
  }

  refresh() {
    if (this.state.heatmapId > 0) {
      this.setState({
        heatmap_path: "",
      });
      this.state.heatmap_path = "";
      this.props.root.refs.API.request("generate_heatmap_by_heatmap_id", {heatmap_id: this.state.heatmapId, radius: this.state.radius, resolution: this.state.resolution, alpha: this.state.alpha, normalize: this.state.normalize}, this.generateHeatmapOK, this.generateHeatmapFailed);
      this.props.root.refs.API.request("generate_heatmap_animation_by_heatmap_id", {heatmap_id: this.state.heatmapId, radius: this.state.video_radius, alpha: parseInt(this.state.video_alpha*255), mode: this.state.video_mode}, this.generateHeatmapAnimationOK, this.generateHeatmapFailed);

      // download the heatmap json by heatmap id
      this.props.root.refs.API.request("get_heatmap_json_path_by_heatmap_id", {heatmap_id: this.state.heatmapId}, this.getHeatmapJsonPathOK, this.getHeatmapJsonPathFailed);
    }
  }

  generateHeatmapOK(res) {
    this.setState({
      heatmap_path: res.body['result']['result_heatmap_path'],
      tn_path: res.body['result']['tn_path'],
    });
    this.state.heatmap_path = res.body['result']['result_heatmap_path'];
    this.state.tn_path = res.body['result']['tn_path'];
  }

  generateHeatmapAnimationOK(res) {
    this.setState({
      video_path: res.body['result']['result_heatmap_path'],
    });
    this.state.video_path = res.body['result']['result_heatmap_path'];
  }

  generateHeatmapFailed(err) {
    console.log("generateHeatmapFailed " + err);
  }

  getHeatmapJsonPathOK(res){
    this.setState({
      heatmap_json_path: res.body['result'],
    });
    this.state.heatmap_json_path = res.body['result'];

    // download json file here
    let json_url = Config.HOST_URL() + "heatmaps/" + this.state.heatmap_json_path;
    console.log(json_url);
    this.props.root.refs.API.request_get(json_url, this.onHeatmapJsonFetchedOK, this.onHeatmapJsonFetchedFailed)

  }

  onHeatmapJsonFetchedOK(res){
    // start decoding heatmap json here
    console.log("onHeatmapJsonFetchedOK");

    this.setState({
      heatmapObj: res.body,
      UTCTimeStamp: res.body.UTCTimeStamp,
      UTCTimeStamp_controlPanelManipulation: res.body.UTCTimeStamp_controlPanelManipulation,
      UTCTimeStamp_tagInteractions: res.body.UTCTimeStamp_tagInteractions,
      locale_id: res.body.locale_id,
      manipulationKind: res.body.manipulationKind,
      multiplier: res.body.multiplier,
      stage_id: res.body.stage_id,
      tagInteractions: res.body.tagInteractions,
      tagKind: res.body.tagKind,
      tagRemarks: res.body.tagRemarks,
      time_interval: res.body.time_interval,
      x_focus: res.body.x_focus,
      y_focus: res.body.y_focus,
    });
    this.state.heatmapObj = res.body;
    this.state.UTCTimeStamp = res.body.UTCTimeStamp;
    this.state.UTCTimeStamp_controlPanelManipulation = res.body.UTCTimeStamp_controlPanelManipulation;
    this.state.UTCTimeStamp_tagInteractions = res.body.UTCTimeStamp_tagInteractions;
    this.state.locale_id = res.body.locale_id;
    this.state.manipulationKind = res.body.manipulationKind;
    this.state.multiplier = res.body.multiplier;
    this.state.stage_id = res.body.stage_id;
    this.state.tagInteractions = res.body.tagInteractions;
    this.state.tagKind = res.body.tagKind;
    this.state.tagRemarks = res.body.tagRemarks;
    this.state.time_interval = res.body.time_interval;
    this.state.x_focus = res.body.x_focus;
    this.state.y_focus = res.body.y_focus;

    console.log(this.state.heatmapObj);
    console.log(this.state.manipulationKind);
  }

  onHeatmapJsonFetchedFailed(err){
    console.log("onHeatmapJsonFetchedFailed");
  }

  getHeatmapJsonPathFailed(err){
    console.log("download heatmap json failed");
  }

  radiusOnChange = (event, value) => {
    this.setState({
      radius: value,
    })
    this.state.radius = value;
  }

  videoRadiusOnChange = (event, value) => {
    this.setState({
      video_radius: value,
    })
    this.state.video_radius = value;
  }

  resolutionOnChange = (event, value) => {
    this.setState({
      resolution: value,
    })
    this.state.resolution = value;
  }

  alphaOnChange = (event, value) => {
    this.setState({
      alpha: value,
    })
    this.state.alpha = value;
  }

  videoAlphaOnChange = (event, value) => {
    this.setState({
      video_alpha: value,
    })
    this.state.video_alpha = value;
  }

  processHeatmapClicked() {
    this.setState({
      heatmap_path: "",
    });
    this.state.heatmap_path = "";
    this.refresh();
  }

  processVideoHeatmapClicked(){
    this.setState({
      video_path: "",
    });
    this.state.video_path = "";
    this.refresh();
  }

  onVideoModeChanged(e){
    this.setState({
      video_mode: e.target.value,
    });
    this.state.video_mode = e.target.value;
  }

  render() {
    // return (
    //   <div style={{maxHeight:this.props.maxHeight, overflow:'auto'}}>
    //     <CompareAnswerDialog root={this.props.root} parent={this} ref="compareAnswerDialog"/>
    //     <StatisticsDialog root={this.props.root} parent={this} ref="statisticsDialog"/>

    //     {this.state.stageList.map( (row, i) => {
    //       return (
    //         <SubmissionDetailStage parent={this} root={this.props.root}
    //           stageData={row['stage_detail']}
    //           answerDataList={row['answer_list']}
    //           key={row['stage_detail']['id']}
    //         />
    //       );
    //     })}
    //   </div>
    // )
    return (
      <div style={{margin:"0 32px 16px 32px"}}>
        <If condition={this.state.heatmapId != 0}>
          <Then>
            <Card style={{margin:"0 16px 16px 0", boxShadow: '0 2px 4px rgba(0,0,0,0.1)'}}>
              <CardHeader
                title={
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="h5" style={{
                      fontWeight: 600,
                      background: `linear-gradient(120deg, ${this.props.theme.palette.primary.main}28 75%, transparent 75%)`,
                      display: 'inline',
                      padding: '4px 8px',
                      borderRadius: '4px',
                      color: this.props.theme.palette.primary.main
                    }}>
                      Heat Map
                    </Typography>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <Tooltip title={Localization.strings.DOWNLOAD} placement="top">
                        <a href={Config.HOST_URL() + this.state.heatmap_path} download target="_blank" style={{textDecoration: 'none'}}>
                          <IconButton
                            size="small"
                            style={{
                              color: this.props.theme.palette.primary.main,
                              padding: '8px'
                            }}
                          >
                            <Icon>download</Icon>
                          </IconButton>
                        </a>
                      </Tooltip>
                      <Tooltip title="Advanced Settings" placement="top">
                        <IconButton
                          size="small"
                          onClick={() => this.setState({ showHeatmapAdvanced: !this.state.showHeatmapAdvanced })}
                          style={{
                            color: this.props.theme.palette.primary.main,
                            padding: '8px',
                            backgroundColor: this.state.showHeatmapAdvanced ? 'rgba(227, 62, 127, 0.08)' : 'transparent'
                          }}
                        >
                          <Icon>{this.state.showHeatmapAdvanced ? 'expand_less' : 'tune'}</Icon>
                        </IconButton>
                      </Tooltip>
                    </div>
                  </div>
                }
              />
              <div style={{padding:"32px"}}>
                <If condition={this.state.heatmap_path != ""}>
                  <Then>
                    <img 
                      width="100%" 
                      src={Config.HOST_URL() + this.state.tn_path} 
                      alt={this.state.tn_path.replace(/^.*[\\\/]/, '')}
                      onClick={() => this.setState({ showImageModal: true, selectedImage: Config.HOST_URL() + this.state.tn_path })}
                      style={{ cursor: 'pointer' }}
                    />
                    <img 
                      width="100%" 
                      src={Config.HOST_URL() + this.state.heatmap_path} 
                      alt={this.state.heatmap_path.replace(/^.*[\\\/]/, '')}
                      onClick={() => this.setState({ showImageModal: true, selectedImage: Config.HOST_URL() + this.state.heatmap_path })}
                      style={{ cursor: 'pointer' }}
                    />
                    
                    <If condition={this.state.showHeatmapAdvanced}>
                      <Then>
                        <div style={{
                          backgroundColor: '#f8f9fa',
                          padding: '24px',
                          borderRadius: '8px',
                          marginTop: '24px'
                        }}>
                          <Typography variant="subtitle1" style={{
                            color: this.props.theme.palette.primary.main,
                            fontWeight: 600,
                            marginBottom: '16px'
                          }}>
                            Advanced Settings
                          </Typography>
                          <Grid container spacing={3} alignItems="center">
                            <Grid item xs={12} sm={3}>
                              <Typography variant="subtitle2" style={{color: '#5f6368', fontWeight: 500}}>
                                {Localization.strings.HEATMAP_RADIUS}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                              <Slider
                                value={this.state.radius}
                                min={2}
                                max={96}
                                step={2}
                                valueLabelDisplay="auto"
                                marks={[{value: 2, label: '2'}, {value: 96, label: '96'}]}
                                onChange={this.radiusOnChange}
                                style={{color: this.props.theme.palette.primary.main}}
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <Typography variant="subtitle2" style={{color: '#5f6368', fontWeight: 500}}>
                                {Localization.strings.HEATMAP_RESOLUTION}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                              <Slider
                                value={this.state.resolution}
                                min={171}
                                max={671}
                                step={10}
                                valueLabelDisplay="auto"
                                marks={[{value: 171, label: '171'}, {value: 671, label: '671'}]}
                                onChange={this.resolutionOnChange}
                                style={{color: this.props.theme.palette.primary.main}}
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <Typography variant="subtitle2" style={{color: '#5f6368', fontWeight: 500}}>
                                {Localization.strings.HEATMAP_ALPHA}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                              <Slider
                                value={this.state.alpha}
                                min={0.1}
                                max={1}
                                step={0.1}
                                valueLabelDisplay="auto"
                                marks={[{value: 0.1, label: '0.1'}, {value: 1, label: '1'}]}
                                onChange={this.alphaOnChange}
                                style={{color: this.props.theme.palette.primary.main}}
                              />
                            </Grid>
                          </Grid>
                          <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: '24px'}}>
                            <Tooltip title="Update Heatmap Settings" placement="top">
                              <Button
                                color="primary"
                                variant="contained"
                                onClick={this.processHeatmapClicked}
                                style={{
                                  minWidth: 'unset',
                                  padding: '8px',
                                  backgroundColor: this.props.theme.palette.primary.main,
                                  borderRadius: '8px',
                                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                  transition: 'all 0.2s ease',
                                  '&:hover': {
                                    backgroundColor: this.props.theme.palette.primary.dark,
                                    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                                  }
                                }}
                              >
                                <Icon>update</Icon>
                              </Button>
                            </Tooltip>
                          </div>
                        </div>
                      </Then>
                    </If>
                  </Then>
                  <Else>
                    <ReactLoading type="balls" color="#E33E7F" 
                      height={100} width={50} />
                  </Else>
                </If>
              </div>
            </Card>
            <Card style={{margin:"0 16px 16px 0", boxShadow: '0 2px 4px rgba(0,0,0,0.1)'}}>
              <CardHeader
                title={
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="h5" style={{
                      fontWeight: 600,
                      background: `linear-gradient(120deg, ${this.props.theme.palette.primary.main}28 75%, transparent 75%)`,
                      display: 'inline',
                      padding: '4px 8px',
                      borderRadius: '4px',
                      color: this.props.theme.palette.primary.main
                    }}>
                      Observation Path
                    </Typography>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <Tooltip title={Localization.strings.DOWNLOAD} placement="top">
                        <a href={Config.HOST_URL() + this.state.video_path} download target="_blank" style={{textDecoration: 'none'}}>
                          <IconButton
                            size="small"
                            style={{
                              color: this.props.theme.palette.primary.main,
                              padding: '8px'
                            }}
                          >
                            <Icon>download</Icon>
                          </IconButton>
                        </a>
                      </Tooltip>
                      <Tooltip title="Advanced Settings" placement="top">
                        <IconButton
                          size="small"
                          onClick={() => this.setState({ showObservationAdvanced: !this.state.showObservationAdvanced })}
                          style={{
                            color: this.props.theme.palette.primary.main,
                            padding: '8px',
                            backgroundColor: this.state.showObservationAdvanced ? 'rgba(227, 62, 127, 0.08)' : 'transparent'
                          }}
                        >
                          <Icon>{this.state.showObservationAdvanced ? 'expand_less' : 'tune'}</Icon>
                        </IconButton>
                      </Tooltip>
                    </div>
                  </div>
                }
              />
              <div style={{padding:"32px"}}>
                <If condition={this.state.video_path != ""}>
                  <Then>
                    <ReactPlayer
                      ref="reactPlayer"
                      width="100%"
                      height="100%"
                      url={Config.HOST_URL() + this.state.video_path}
                      playing={false}
                      controls={true}
                      playsinline={true}
                      onProgress={this.reactPlayerOnProgress}
                      progressInterval={50}
                    />
                    
                    <Typography variant="h6" style={{color: '#202124', fontWeight: 500, marginTop: '24px', marginBottom: '12px'}}>
                      Stage Control
                    </Typography>
                    <div style={{height:'110px'}} ref="div">
                      <ScrollMenu
                        ref="scrollMenuManipulation"
                        style={{height:'90px'}}
                        data={
                          this.state.manipulationKind.map((row, i) => {
                            var triggerTime = Helper.UTCTimestampSecondsBetween(this.state.UTCTimeStamp_controlPanelManipulation[i], this.state.UTCTimeStamp[0]);
                            const isActive = triggerTime >= this.state.playedSeconds;
                            return(
                              <div style={{padding:'1px 14px 6px 1px'}} key={i}>
                                <Card 
                                  style={{
                                    backgroundColor: isActive ? '#ffffff' : '#e8f5e9',
                                    borderRadius: '8px',
                                    transition: 'all 0.3s ease',
                                    border: '1px solid',
                                    borderColor: isActive ? '#e0e0e0' : this.props.theme.palette.primary.light,
                                    boxShadow: isActive ? '0 1px 3px rgba(0,0,0,0.12)' : `0 2px 4px ${this.props.theme.palette.primary.light}40`,
                                    minWidth: '200px'
                                  }}
                                >
                                  <CardActionArea
                                    onClick={()=>this.scrollMenuManipulationCardClicked(triggerTime)}
                                    style={{padding: '8px 16px'}}
                                  >
                                    <CardContent style={{padding: '8px 0'}}>
                                      <Typography variant="subtitle1" style={{
                                        color: isActive ? '#202124' : this.props.theme.palette.primary.dark,
                                        fontWeight: 500,
                                        marginBottom: '4px'
                                      }}>
                                        {Config.GET_MANIPULATION_KIND(row)}
                                      </Typography>
                                      <Typography variant="body2" style={{
                                        color: isActive ? '#5f6368' : this.props.theme.palette.primary.main,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px'
                                      }}>
                                        <Icon style={{fontSize: '16px'}}>schedule</Icon>
                                        {Helper.fToHHMMSS(triggerTime)}
                                      </Typography>
                                    </CardContent>
                                  </CardActionArea>
                                </Card>
                              </div>
                            );
                          })
                        }
                        arrowLeft={<IconButton><Icon>keyboard_arrow_left</Icon></IconButton>}
                        arrowRight={<IconButton><Icon>keyboard_arrow_right</Icon></IconButton>}
                        hideArrows={true}
                        hideSingleArrow={true}
                        alignCenter={false}
                      />
                    </div>

                    <Typography variant="h6" style={{color: '#202124', fontWeight: 500, marginTop: '24px', marginBottom: '12px'}}>
                      Tag Interaction
                    </Typography>
                    <div style={{height:'110px'}} ref="div">
                      <ScrollMenu
                        ref="scrollMenuInteration"
                        style={{height:'90px'}}
                        data={
                          this.state.tagInteractions.map((row, i) => {
                            var triggerTime = Helper.UTCTimestampSecondsBetween(this.state.UTCTimeStamp_tagInteractions[i], this.state.UTCTimeStamp[0]);
                            const isActive = triggerTime >= this.state.playedSeconds;
                            return(
                              <div style={{padding:'1px 14px 6px 1px'}} key={i}>
                                <Card 
                                  style={{
                                    backgroundColor: isActive ? '#ffffff' : '#e3f2fd',
                                    borderRadius: '8px',
                                    transition: 'all 0.3s ease',
                                    border: '1px solid',
                                    borderColor: isActive ? '#e0e0e0' : this.props.theme.palette.primary.light,
                                    boxShadow: isActive ? '0 1px 3px rgba(0,0,0,0.12)' : `0 2px 4px ${this.props.theme.palette.primary.light}40`,
                                    minWidth: '200px'
                                  }}
                                >
                                  <CardActionArea
                                    onClick={()=>this.scrollMenuInterationCardClicked(triggerTime)}
                                    style={{padding: '8px 16px'}}
                                  >
                                    <CardContent style={{padding: '8px 0'}}>
                                      <Typography variant="subtitle1" style={{
                                        color: isActive ? '#202124' : this.props.theme.palette.primary.dark,
                                        fontWeight: 500,
                                        marginBottom: '4px'
                                      }}>
                                        {Config.GET_INTERACTION_KIND(row)}
                                      </Typography>
                                      <Typography variant="body2" style={{
                                        color: isActive ? '#5f6368' : this.props.theme.palette.primary.main,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px'
                                      }}>
                                        <Icon style={{fontSize: '16px'}}>schedule</Icon>
                                        {Helper.fToHHMMSS(triggerTime)}
                                      </Typography>
                                    </CardContent>
                                  </CardActionArea>
                                </Card>
                              </div>
                            );
                          })
                        }
                        arrowLeft={<IconButton><Icon>keyboard_arrow_left</Icon></IconButton>}
                        arrowRight={<IconButton><Icon>keyboard_arrow_right</Icon></IconButton>}
                        hideArrows={true}
                        hideSingleArrow={true}
                        alignCenter={false}
                      />
                    </div>

                    <If condition={this.state.showObservationAdvanced}>
                      <Then>
                        <div style={{
                          backgroundColor: '#f8f9fa',
                          padding: '24px',
                          borderRadius: '8px',
                          marginTop: '24px'
                        }}>
                          <Typography variant="subtitle1" style={{
                            color: this.props.theme.palette.primary.main,
                            fontWeight: 600,
                            marginBottom: '16px'
                          }}>
                            Advanced Settings
                          </Typography>
                          <Grid container spacing={3} alignItems="center">
                            <Grid item xs={12} sm={3}>
                              <Typography variant="subtitle2" style={{color: '#5f6368', fontWeight: 500}}>
                                {Localization.strings.HEATMAP_RADIUS}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                              <Slider
                                value={this.state.video_radius}
                                min={2}
                                max={96}
                                step={2}
                                valueLabelDisplay="auto"
                                marks={[{value: 2, label: '2'}, {value: 96, label: '96'}]}
                                onChange={this.videoRadiusOnChange}
                                style={{color: this.props.theme.palette.primary.main}}
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <Typography variant="subtitle2" style={{color: '#5f6368', fontWeight: 500}}>
                                {Localization.strings.HEATMAP_ALPHA}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                              <Slider
                                value={this.state.video_alpha}
                                min={0.1}
                                max={1}
                                step={0.1}
                                valueLabelDisplay="auto"
                                marks={[{value: 0.1, label: '0.1'}, {value: 1, label: '1'}]}
                                onChange={this.videoAlphaOnChange}
                                style={{color: this.props.theme.palette.primary.main}}
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <Typography variant="subtitle2" style={{color: '#5f6368', fontWeight: 500}}>
                                {Localization.strings.HEATMAP_ANIMATION_MODE}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                              <FormControl fullWidth>
                                <Select
                                  value={this.state.video_mode}
                                  onChange={this.onVideoModeChanged}
                                >
                                  <MenuItem value={0}>{Localization.strings.HEATMAP_ANIMATION_MODE_STANDARD}</MenuItem>
                                  <MenuItem value={1}>{Localization.strings.HEATMAP_ANIMATION_MODE_FILLING_MODE}</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                          </Grid>
                          <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: '24px'}}>
                            <Tooltip title="Update Observation Path Settings" placement="top">
                              <Button
                                color="primary"
                                variant="contained"
                                onClick={this.processVideoHeatmapClicked}
                                style={{
                                  minWidth: 'unset',
                                  padding: '8px',
                                  backgroundColor: this.props.theme.palette.primary.main,
                                  borderRadius: '8px',
                                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                  transition: 'all 0.2s ease',
                                  '&:hover': {
                                    backgroundColor: this.props.theme.palette.primary.dark,
                                    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                                  }
                                }}
                              >
                                <Icon>update</Icon>
                              </Button>
                            </Tooltip>
                          </div>
                        </div>
                      </Then>
                    </If>
                  </Then>
                  <Else>
                    <ReactLoading type="balls" color="#E33E7F" 
                      height={100} width={50} />
                  </Else>
                </If>
              </div>
            </Card>
          </Then>
        </If>
        <Dialog
          open={this.state.showImageModal}
          onClose={() => this.setState({ showImageModal: false })}
          maxWidth={false}
          PaperProps={{
            style: {
              backgroundColor: 'transparent',
              boxShadow: 'none',
              borderRadius: 0,
              overflow: 'hidden',
            },
          }}
        >
          <DialogContent style={{ 
            padding: 0, 
            position: 'relative', 
            borderRadius: 0,
            width: '90vw',
            height: '90vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden'
          }}>
            <div style={{
              position: 'absolute',
              right: 8,
              top: 8,
              display: 'flex',
              gap: '8px',
              zIndex: 1,
            }}>
              <Tooltip title="Zoom Out" placement="bottom">
                <IconButton
                  onClick={() => this.setState(prevState => ({ imageScale: Math.max(0.1, prevState.imageScale - 0.1) }))}
                  style={{
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    color: '#fff',
                    '&:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    }
                  }}
                >
                  <Icon>remove</Icon>
                </IconButton>
              </Tooltip>
              <Tooltip title="Zoom In" placement="bottom">
                <IconButton
                  onClick={() => this.setState(prevState => ({ imageScale: Math.min(3, prevState.imageScale + 0.1) }))}
                  style={{
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    color: '#fff',
                    '&:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    }
                  }}
                >
                  <Icon>add</Icon>
                </IconButton>
              </Tooltip>
              <Tooltip title="Close" placement="bottom">
                <IconButton
                  onClick={() => this.setState({ showImageModal: false, imageScale: 1 })}
                  style={{
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    color: '#fff',
                    '&:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    }
                  }}
                >
                  <Icon>close</Icon>
                </IconButton>
              </Tooltip>
            </div>
            <img
              src={this.state.selectedImage}
              alt="Full size"
              style={{
                maxWidth: '90vw',
                maxHeight: '90vh',
                objectFit: 'contain',
                backgroundColor: 'black',
                transform: `scale(${this.state.imageScale})`,
                transition: 'transform 0.2s ease-in-out'
              }}
            />
          </DialogContent>
        </Dialog>
      </div>
    )
  }
}

export default withTheme(HeatmapDetail);
